import React, { Fragment as _, memo } from 'react';
import { Row, Column } from '@chameleoncreator/creator-ui';
import { Block } from '@chameleoncreator/creator-app';
import { Accordion, Field, FieldHeader, FieldBody } from './Accordion';
import EditableText from 'components/lib/EditableText';
import Image from '../Image';
import Container from 'components/Layouts/ContainerLogical';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import EditableButton from 'components/lib/EditableBtn';
import getBlockById from 'services/apiHelpers/getBlockById';
import { interactionContext } from './interactionContext';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import Transcript from 'components/lib/Video/Transcript';
import SVG from 'components/lib/SVG';
import Media from 'components/lib/Media';
import IELayout from 'components/Layouts/IELayout';
import shouldUpdate from 'services/shouldUpdate';
import hatLaptopGuy from 'assets/animations/hatLaptopGuy.js';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const ComponentsObject = {
  Row,
  Column,
  Text: EditableText,
  Accordion: ({ children, ...props }) => {
    return (
      <div style={{ width: '100%' }}>
        <Accordion {...props}>{children}</Accordion>
      </div>
    );
  },
  AccordionField: Field,
  AccordionHeader: FieldHeader,
  AccordionBody: FieldBody,
  // Image,

  Image: ({ children, ...props }) => {
    // if (!props.src || props.src === Accordion_Placeholder_img) {
    if (!props.src) {
      const updatedProps = {
        ...props,
        src: JSON.stringify(hatLaptopGuy),
      };

      return <SVG {...updatedProps} />;
    }
    return <Image {...props} />;
  },

  Video: ({ children, ...props }) => {
    return (
      <_>
        <Video {...props}>{children}</Video>
        {props.useTranscript && <div style={{ height: 30 }} />}
      </_>
    );
  },
  Audio,
  Transcript,
  Modal: () => null,
  SVG,
  Embed: () => null,
  Media,
  PDF: () => null,
  OpenPDF: () => null,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton,
  ...IELayout(interactionContext),
};

const render = (block: Block, Components: {}): JSX.Element | string => {
  let b = block;
  if (b.type === 'Ref') {
    b = getBlockById(b.id);
  }

  const children = Array.isArray(b.children)
    ? (b.children as Block[]).map(c => render(c, Components))
    : b.children;

  const Component = Components[b.type];

  return (
    <Component key={b.id} id={b.id} {...b.props}>
      {children}
    </Component>
  );
};

interface DisplayProps {
  blockId: string;
  interactionBlock?: Block;
}

const AccordionDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider value={interactionBlock}>
        {(interactionBlock.children as Block[]).map(child => {
          return render(child, ComponentsObject);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default AccordionDisplay;
